import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import InputFactory from "../../../../components/InputFactory";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import OfficeFormPresenter from "../../../OrganizationaStructure/offices/office-form/OfficeFormPresenter";
import FormTable from "../../../../components/common/Converter";
import ArrayTable from "./position-table/ArrayTable";
import BooleanTable from "./position-table/BooleanTable";
import Hierarchy from "../../../../components/common/Hierarchy";

class PositionTitleFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      salaryGrade: [],
      // offices: [],
      // divisions: [],
      positionRows: [], //array PositionTitle No. 15
      responsibilityRows: [], //array STATEMENT OF DUTIES No. 22
      Province: false,
      City: false,
      Municipality: false,
      First_Class: false,
      Second_Class: false,
      Third_Class: false,
      Fourth_Class: false,
      Fifth_Class: false,
      Sixth_Class: false,
      Seventh_Class: false,
      Special: false,
      position_title: "",
      item_number: "",
      salary_grade: "",
      agencyOrLocal_government: "",
      // office: "",
      // division: "",
      workstation: "",
      present_approp_act: "",
      prev_approp_act: "",
      salary_authorized: "",
      other_compensation: "",
      immediate_supervisor: "",
      next_higher_supervisor: "",
      machine_tools: "",
      education: "",
      experience: "",
      training: "",
      eligibility: "",
      corecompetencies: "",
      competencylevel: "",
      leadershipcompetencies: "",
      levelcompetency: "",
      unitofsection: "",
      jobsummary: "",
      executive: { Occasional: false, Frequent: false },
      supervisors: { Occasional: false, Frequent: false },
      nonsupervisors: { Occasional: false, Frequent: false },
      staff: { Occasional: false, Frequent: false },
      general: { Occasional: false, Frequent: false },
      agencies: { Occasional: false, Frequent: false },
      officework: { Occasional: false, Frequent: false },
      fieldwork: { Occasional: false, Frequent: false },
      otherStakeholder: "",
      otherWorking: "",
      salaryPointer: {},
      hierarchy: {},
    };
    this.presenter = new OfficeFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
    );
  }

  getCollectionName() {
    return "position_titles";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const salaryGrade = await findObjectUseCase().execute("salary_grade", {
      where: { status: "active" },
    });

    salaryGrade.sort((a, b) => {
      const getParts = (name) => {
        const match = name.match(/Salary Grade (\d+)\s*-\s*Step (\d+)/i);

        return {
          grade: parseInt(match?.[1] || 0),
          step: parseInt(match?.[2] || 0),
        };
      };

      const aParts = getParts(a.name);
      const bParts = getParts(b.name);

      if (aParts.grade !== bParts.grade) {
        return aParts.grade - bParts.grade;
      }

      return aParts.step - bParts.step;
    });

    this.setState({
      salaryGrade,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      console.log("OBJ: ", this.state.object);
      this.setState(this.state.object);
      // const hierarchy = {
      //   ...this.state.object,
      // };
      // this.setState({ hierarchy });
    }
  }

  handleObjectChange(data) {
    this.setState({ hierarchy: data });
  }

  async handleFormChange(field, value) {
    // if (field === "office") {
    //   const divisions = await findObjectUseCase().execute("Division", {
    //     where: { status: "active", office: value },
    //   });
    //   this.setState({ [field]: value, divisions });
    // } else
    if (field === "salary_grade") {
      this.setState({ [field]: value[0], salaryPointer: { id: value[1] } });
    } else {
      this.setState({ [field]: value });
    }
  }
  boolOnChange(field, event) {
    this.setState({ [field]: event.target.checked });
  }

  stackholderOnChange(field, frequency, event) {
    this.setState((prevState) => ({
      [field]: {
        ...prevState[field],
        [frequency]: event.target.checked,
      },
    }));
  }

  addPosition() {
    this.setState((prevState) => ({
      positionRows: [...prevState.positionRows, { title: "", itemNum: "" }],
    }));
  }

  addResponsibility() {
    this.setState((prevState) => ({
      responsibilityRows: [
        ...prevState.responsibilityRows,
        { percentage: "", duties: "", competency: "" },
      ],
    }));
  }

  onUpdateRows(updatedRows) {
    this.setState({ positionRows: updatedRows });
  }

  onResponsibilities(updatedRows) {
    this.setState({ responsibilityRows: updatedRows });
  }

  async handleSubmitData() {
    const { salaryGrade, object, hierarchy, loading, ...data } = this.state;
    const hierarchyObj = {
      acl: {},
      ...hierarchy,
    };

    try {
      if (Object.keys(object).length > 0) {
        const update = { id: object.id, ...data, ...hierarchyObj };

        await upsertUseCase().execute("position_titles", update);
      } else {
        const obj = { ...data, ...hierarchyObj };
        await upsertUseCase().execute("position_titles", obj);
      }
      this.presenter.showSuccess("Successfully saved!");
    } catch (e) {
      console.error(e);
    }
  }

  render() {
    const {
      salaryGrade,
      offices,
      divisions,
      positionRows,
      responsibilityRows,
      object,
    } = this.state;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>No schema</h1>;

    const path = this.props.location.pathname;
    const isViewMode = path.startsWith("/view/");

    // console.log("POSITION: ", object);

    const renderFormTable = (title, child) => (
      <FormTable title={title} child={child} />
    );

    const renderInputFactory = (label) => (
      <InputFactory
        type="Text"
        required={label.required}
        disabled={isViewMode}
        value={this.state[label.field]}
        onChange={(value) => this.handleFormChange(label.field, value)}
      />
    );

    const renderSearchSelect = (label, options) => (
      <div className="p-0 m-0" style={{ minHeight: "4rem" }}>
        {label.field === "salary_grade" ? (
          <SearchSelect
            value={this.state[label.field]}
            focus={true}
            required={label.required}
            onChange={(value) => this.handleFormChange(label.field, value)}
            disabled={isViewMode}
            options={options.map((item) => ({
              label: item.name,
              value: [item.name, item.id],
            }))}
          />
        ) : (
          <SearchSelect
            value={this.state[label.field]}
            onChange={(value) => this.handleFormChange(label.field, value)}
            disabled={isViewMode}
            options={options.map((item) => ({
              label: item.name,
              value: item.name,
            }))}
          />
        )}
      </div>
    );

    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.handleSubmitData();
              }}
            >
              <div className="p-3 p-lg-4">
                <h1 className="fw-bold mt-3 text-capitalize">
                  {(schema.label || this.getCollectionName()) + " Details"}
                </h1>
                <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                  <div className="row ">
                    {[
                      { field: "position_title", required: true },
                      { field: "salary_grade", required: false },
                      { field: "undertakingOfDuty", required: true },
                      { field: "placeOfAssignment", required: true },
                    ].map((label, index) => (
                      <div className="col-lg-6" key={label.field}>
                        {renderFormTable(
                          label.field === "undertakingOfDuty"
                            ? "Undertaking of duty and assignment".toUpperCase()
                            : label.field === "placeOfAssignment"
                              ? "place of assignment".toUpperCase()
                              : `${label.field.replace("_", " ").toUpperCase()}`,
                          label.field !== "salary_grade"
                            ? renderInputFactory(label)
                            : renderSearchSelect(label, salaryGrade),
                        )}
                      </div>
                    ))}
                  </div>

                  {/* <div className="col-lg-6">
                  <label>
                    Undertaking of duty and assignment
                    <span className="text-danger">*</span>
                  </label>
                  <InputFactory
                    type="String"
                    _type="Text"
                    field="undertakingOfDuty"
                    object={object}
                    placeholder="Undertaking of duty and assignment"
                    onChange={(value, label) =>
                      this.handleFormChange(label, value)
                    }
                    required={true}
                  />
                </div> */}

                  <div className="col-lg-12">
                    {renderFormTable(
                      "Organizational Structure",

                      <Hierarchy
                        className="col-lg-6 p-2"
                        object={this.state.object}
                        disabled={isViewMode}
                        handleObjectChange={this.handleObjectChange.bind(this)}
                      />,
                    )}
                  </div>
                  <div className="col-lg-12">
                    {renderFormTable("QUALIFICATION STANDARDS")}
                    <div className="row">
                      {[
                        { field: "education", required: false },
                        { field: "experience", required: false },
                        { field: "training", required: false },
                        { field: "eligibility", required: false },
                        // "Core Competencies",
                        // "Competency Level",
                        // "Leadership Competencies",
                        // "Level Competency",
                      ].map((label, index) => {
                        const letter = String.fromCharCode(97 + index);
                        return (
                          <div
                            className={index <= 3 ? "col-lg-3" : "col-lg-6"}
                            key={label.field}
                          >
                            {renderFormTable(
                              `${label.field}`,
                              renderInputFactory(label),
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="mt-4">
                    {!isViewMode && (
                      <button
                        type="submit"
                        className="btn btn-primary fs-sm me-3"
                        // onClick={() => this.handleSubmitData()}
                      >
                        <i className="bi bi-file-earmark-check me-2"></i>
                        {label}
                      </button>
                    )}

                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </div>
                {/* dlete */}
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(PositionTitleFormPage);
